import { AfterViewInit, Directive, ElementRef, Self } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

@Directive({
  selector: '[jhiMarkAsterisk]',
  standalone: true,
})
export class MarkAsteriskDirective implements AfterViewInit {
  constructor(@Self() private ngControl: NgControl, private el: ElementRef) {}

  ngAfterViewInit(): void {
    const isRequired = this.ngControl.control?.hasValidator(Validators.required);
    if (isRequired) {
      const childs = this.el.nativeElement.parentElement.childNodes as NodeList;
      setTimeout(() => this.extracted(childs), 100);
    }
  }

  private extracted(childs: NodeList): void {
    if (childs.length > 0) {
      childs.forEach((val: Node) => {
        if (val.nodeName === 'LABEL') {
          const label = val as HTMLElement;
          // Avoid duplicating asterisks
          if (!label.innerHTML.endsWith(' <span class="asterisk"></span>')) {
            label.innerHTML += ' <span class="asterisk"></span>';
          }
        } else if (val.childNodes.length > 0) {
          this.extracted(val.childNodes);
        }
      });
    }
  }
}
